import { uniq } from 'lodash-es';

import { ContextHolder, ContextMetadata, ContextReason } from '../record/entities/metadata.entity';

export const ExtractContextReasons = (
    record: ContextHolder,
    action: keyof ContextMetadata | undefined,
    defaultDisabledMsg: string
): string => {
    if (action === undefined) {
        // Fallback, shouldn't happen
        return '';
    }
    const reasons: ContextReason[] | undefined = record?.Context?.Reasons ? record.Context.Reasons[action] : [];
    const reason: string[] = (reasons || [])
        .filter((reason): reason is ContextReason => !!reason)
        .map(reason => reason.Value);

    const disabledInfoMsg = reason && reason.length > 0 ? uniq(reason).join() : defaultDisabledMsg;

    return !record?.Context[action] ? disabledInfoMsg : '';
};
